import { useContext, useMemo } from 'react';

import { DisplayNamesLastFirstContext } from '@apps/web/context/display_names_last_first_context';
import {
    formatCaregiverName,
    formatPersonNameParts,
} from '@apps/web/lib/caregiver_name';

export function useDisplayNamesLastFirst(): boolean {
    return useContext(DisplayNamesLastFirstContext);
}

export function useFormatPersonName(): {
    displayLastFirst: boolean;
    formatName: (fullName: string | null | undefined) => string;
    formatNameParts: (
        firstName: string | null | undefined,
        lastName: string | null | undefined,
    ) => string;
} {
    const displayLastFirst = useDisplayNamesLastFirst();
    return useMemo(
        () => ({
            displayLastFirst,
            formatName: (fullName: string | null | undefined) =>
                fullName === null || fullName === undefined
                    ? ''
                    : formatCaregiverName(fullName, displayLastFirst),
            formatNameParts: (
                firstName: string | null | undefined,
                lastName: string | null | undefined,
            ) => formatPersonNameParts(firstName, lastName, displayLastFirst),
        }),
        [displayLastFirst],
    );
}
